import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';

@Feature()
export class AutoAdjustSlideFeature extends BaseToolbarFeature {
    public id = config.id;
    public config = config;
    public constructor() {
        super();
    }

    public onClick() {
        this.getAppService()
            .viewableServiceLayer.editAreaCanvasSizeManager.setIsAutoAdapter(true);
        window.dispatchEvent(new CustomEvent('resize', { detail: { countSizeAgain: true } })); // 主动触发window resize
    }
}
